module.exports = __webpack_public_path__ + "img/liulv.a37c54b4.png";